/*
 *   Copyright (c) 2021 vlinder Inc.
 *   All rights reserved.
 *   This software is proprietary of vlinder Inc. and can not be distributed / used for any purpose outside of vlinder Inc. without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from 'react';
import { ViewportProvider } from '@vlinder-web/viewport-provider-react';
import { AppNavigator } from '../AppNavigator';
import { ThemeProvider } from '../providers/theme';

import { Accessories } from './Accessories';

export const BootstrapApp = () => {
  return (
    <>
      <ThemeProvider>
        <ViewportProvider>
          <AppNavigator />
        </ViewportProvider>
      </ThemeProvider>
      <Accessories />
    </>
  );
};
